import { Controller } from "@hotwired/stimulus"

// Copy the embed snippet to the clipboard with a transient "Copied!" label.
// Theme switching now lives on widget-preview, which owns the live preview and
// keeps this snippet's data-theme in sync.
export default class extends Controller {
  static targets = ["button", "snippet"]
  // The confirmation label is passed in from the view so it follows the account
  // locale — this controller is instantiated once per snippet (the card plus one
  // per install-guide modal), and each one shows its own copy of it.
  static values = { copiedLabel: { type: String, default: "Copied!" } }

  copy() {
    const snippet = this.hasSnippetTarget ? this.snippetTarget : document.getElementById("embed-snippet")
    if (!snippet) return

    navigator.clipboard.writeText(snippet.textContent).then(() => {
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = this.copiedLabelValue
      setTimeout(() => {
        this.buttonTarget.textContent = original
      }, 2000)
    })
  }
}
